import { render, staticRenderFns } from "./UploadImageDialog.vue?vue&type=template&id=2652200b&scoped=true"
import script from "./UploadImageDialog.vue?vue&type=script&lang=js"
export * from "./UploadImageDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadImageDialog.vue?vue&type=style&index=0&id=2652200b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652200b",
  null
  
)

export default component.exports